import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const conveyor = defineConnector({
  identifier: "conveyor",
  name: "Conveyor",
  tagLine: "Trust center and security questionnaires",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.conveyor\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Conveyor](https://app.conveyor.com/), go to **Settings > Organization > Integrations**, add an integration, and choose **Conveyor API**. You need the Superadmin or Conveyor Admin role.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.conveyor.com/api/v2/exchange/connections",
  },
});
